import React, { useState, useEffect, useRef } from "react";
import { Card, CardContent, Typography, Container } from "@mui/material";
import { ClearAll, Search } from "@mui/icons-material";
import Grid from "@mui/material/Unstable_Grid2";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
//import { useTheme } from "@emotion/react";
// import FormLogin from '../Patient/FormLogin';
import FormSearchCentral from "./FormSearchCentral";
import FormSearchImagenologia from "./FormSearchImagenologia";
// import FormGuest from '../Patient/FormReservationGuest';
//import { useRecoilState, useRecoilValue } from 'recoil';
import {
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
  useRecoilCallback,
} from "recoil";
//import { activeTabReservationState } from './state/atoms';
//import { activeTabState } from "./state/atoms";
//import { valuesFormReservationGuestState, valuesFormReservationUserState } from 'src/Patient/state/atoms';
//import { useState , useEffect , useRef  } from "react";
//import { useHistory } from "react-router";
import { userNavigate } from "react-router-dom";

import TabsCustom from "src/shared/components/tabs/TabsCustom";
import ButtonCustom from "../shared/components/buttons/ButtonCustom";
import {
  filterSearchSelectedState,
  hoursAvailableState,
  professionalsMatchCovenantState,
  professionalsNoMatchCovenantState,
  activeTabState,
} from "./state/atoms";

import {
  covenantsFetchState,
  covenantsState,
  professionalsBySpecialityState,
  professionalsState,
  specialitiesFetchState,
  specialitiesState,
  sucursalesFetchState,
  sucursalesState,
  clinicasFetchState,
  clinicasState,
  atencionFetchState,
  atencionState,
  tipoExamenState,
  tipoExamenesFetchState,
  examenState,
  examenesFetchState,
  ExamenByTipoExamenState,
  serviciosState,
} from "./components/autocompletes/state/atoms";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";
import useSEO from "src/Hooks/useSEO";
import ReactGA from "react-ga4";

import theme from "src/theme/index";
import { grey, common } from "@mui/material/colors";

export default function TabsSearchCentral({ md = 12, buttonSearch = null, buttonClear = null }) {
  const [loading, setLoading] = useState(false);
  //const history = useHistory();
  const [activeTabSearch, setActiveTabSearch] = useRecoilState(activeTabState);
  const mountedRef = useRef(true);
  const { catchErrorApi } = useCatchErrorApi();

  //const theme = useTheme();

  //const valuesFormReservationGuest = useRecoilValue(valuesFormReservationGuestState);
  //const valuesFormReservationUser = useRecoilValue(valuesFormReservationUserState)
  const setProfessionals = useSetRecoilState(professionalsState);
  const setSpecialities = useSetRecoilState(specialitiesState);
  const setCovenants = useSetRecoilState(covenantsState);

  const setTipoExamen = useSetRecoilState(tipoExamenState);
  const setExamen = useSetRecoilState(examenState);
  const setServicio = useSetRecoilState(serviciosState);
  //const filterSearchSelected = useRecoilValue(filterSearchSelectedState);
  const resetFilterSearchSelected = useResetRecoilState(
    filterSearchSelectedState
  );

  const [filterSearchSelected, setFilterSearchSelected] = useRecoilState(
    filterSearchSelectedState
  );

  //const setPreloader = useSetRecoilState(preloaderState);
  const resetProfessionalsMatchCovenant = useResetRecoilState(
    professionalsMatchCovenantState
  );
  const resetProfessionalsNoMatchCovenant = useResetRecoilState(
    professionalsNoMatchCovenantState
  );
  const resetHoursAvailable = useResetRecoilState(hoursAvailableState);

  const [tabsDisabled, setTabsDisabled] = useState({
    one: false,
    two: false,
  });

  const setSucursales = useSetRecoilState(sucursalesState);
  const setClinicas = useSetRecoilState(clinicasState);
  const setAtencion = useSetRecoilState(atencionState);

  // const handleChangeTab = (event, newValue) => {
  //   setActiveTabSearch(newValue);
  // };

  const eventGA = () => {
    console.log("Evento Google Analytics -> Buscar");
    let especialidad = filterSearchSelected.specialitySelected.value;
    especialidad = especialidad != "" ? `| Especialidad: ${especialidad}` : "";
    let profesional = filterSearchSelected.professionalSelected.value;
    profesional = profesional != "" ? `| Profesional: ${profesional}` : "";
    let prevision = filterSearchSelected.covenantSelected.value;
    prevision = prevision != "" ? `| Previsión: ${prevision}` : "";
    let clinica = filterSearchSelected.clinicaSelected.value;
    clinica = clinica != "" ? `Clinica: ${clinica}` : "";
    console.log(`ga ${clinica} ${especialidad} ${profesional} ${prevision}`);
    ReactGA.event({
      category: 'Buscar',
      action: `${clinica} ${especialidad} ${profesional} ${prevision}`
    });
  };

  const eventImagenologiaGA = () => {
    console.log("Evento Google Analytics -> Buscar Imagenologia");
    let tipoExamen = filterSearchSelected.tipoExamenSelected.value;
    tipoExamen = tipoExamen != "" ? `| TipoExamen: ${tipoExamen}` : "";
    let examen = filterSearchSelected.examenSelected.value;
    examen = examen != "" ? `| Examen: ${examen}` : "";
    let clinica = filterSearchSelected.clinicaSelected.value;
    clinica = clinica != "" ? `Clinica: ${clinica}` : "";
    console.log(`ga ${clinica} ${tipoExamen} ${examen}`);
    ReactGA.event({
      category: 'Buscar',
      action: `${clinica} ${tipoExamen} ${examen}`
    });
  };

  const loadResultSearchCentral = () => {
    console.log("loadResultSearchCentral...");
    window.location.reload(false);
  };
  // const loadResultSearchCentral = useRecoilCallback(({ snapshot }) => async () => {
  //   const release = snapshot.retain();
  //   setLoading(true)
  //   try {
  //       //if (!mountedRef.current) return null;
  //       console.log('loadResultSearchCentral...');

  //       setFilterSearchSelected({
  //         ...filterSearchSelected,
  //         searchClick: {
  //           value: true,
  //           code: true,
  //         },
  //       });

  //   } catch (error) {
  //       catchErrorApi(error)
  //       console.log(error);
  //   } finally {
  //       setLoading(false)
  //       release()
  //   }
  // }, []);

  // Cargar Sucursales...
  const loadData = useRecoilCallback(
    ({ snapshot }) =>
      async () => {
        const release = snapshot.retain();
        setLoading(true);
        try {
          if (!mountedRef.current) return null;
          // const sucursalesFetch = await snapshot.getPromise(sucursalesFetchState);
          // console.log("sucursalesFetch => ", sucursalesFetch);
          // setSucursales(sucursalesFetch);

          const atencionFetch = await snapshot.getPromise(atencionFetchState);
          console.log("atencionFetch => ", atencionFetch);
          setAtencion(atencionFetch);

          const clinicasFetch = await snapshot.getPromise(clinicasFetchState);
          console.log("clinicasFetch => ", clinicasFetch);
          setClinicas(clinicasFetch);

          console.log("🔥🔥🔥 TabSearchCentral ==> 🔥🔥🔥", activeTabSearch);

          // let sucursalCod = filterSearchSelected.sucursalSelected.value;
          // console.log("FormSearchCentral => ", sucursalCod);
        } catch (error) {
          catchErrorApi(error);
          console.log(error);
        } finally {
          setLoading(false);
          release();
        }
      },
    []
  );

  useEffect(() => {
    loadData();

    return () => {
      loadData();
    };
  }, [loadData]);

  const useStyles = {
    label: {
      color: theme.palette.primary.main,
    },
    autocomplete: {
      color: theme.palette.primary.main,
    },
  };

  return (
    <Box
      sx={{ width: "100%", typography: "body1" }}
      style={{
        marginTop: "1rem",
      }}
    >
      <Card
        style={{
          // borderColor:'#000',
          // borderTopLeftRadius: "0px",
          // borderTopRightRadius: "0px",
          // borderBottomLeftRadius: "0px",
          // borderBottomRightRadius: "0px",
          // backgroundColor: '#f8f8f8'
          boxShadow: "none",
        }}
      >
        <CardContent>
          <FormSearchCentral styles={useStyles} />
        </CardContent>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            p: 2,
          }}
        >
          {/* || filterSearchSelected.examenSelected.value === '' */}
          {/* <ButtonCustom
            disabled={
              filterSearchSelected.professionalSelected.value === "" &&
              filterSearchSelected.specialitySelected.value === "" &&
              filterSearchSelected.examenSelected.value === "" &&
              filterSearchSelected.procedimientoSelected.value === ""
                ? true
                : false
            }
            loading={loading}
            color="secondary"
            text="BUSCAR"
            icon={<Search />}
            style={{ marginRight: 15 }}
            onClick={() => {
              setLoading(true);
              resetProfessionalsMatchCovenant();
              resetProfessionalsNoMatchCovenant();
              resetHoursAvailable();
              eventGA();
              loadResultSearchCentral();
            }}
          />
          <ButtonCustom
            color="default"
            variant="contained"
            text="LIMPIAR"
            icon={<ClearAll />}
            onClick={() => {
              //setLoading(true);
              resetProfessionalsMatchCovenant();
              resetProfessionalsNoMatchCovenant();
              resetFilterSearchSelected();
              resetHoursAvailable();
              setCovenants([]);
              setProfessionals([]);
              setSpecialities([]);
              setTipoExamen([]);
              setExamen([]);
              setServicio([]);
            }}
          />

          {buttonSearch && (
            <Grid
              display={"flex"}
              justifyContent="center"
              alignItems={"center"}
              item
              md={md}
              xs={12}
            >
              {buttonSearch}
            </Grid>
          )} */}

          <Box
            display={"flex"}
            justifyContent="center"
            alignItems={"center"}
            gap={1}
            md={md}
            xs={12}
          >
            {buttonSearch}

            {buttonClear}
          </Box>
        </Box>
      </Card>
    </Box>
  );
}
